import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { MANIPULATE_BENEFICIARIES_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class EditBeneficiaryRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {};

  url = MANIPULATE_BENEFICIARIES_URL;

  constructor(requestBody, paramList) {
    super();
    this.body = requestBody;
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
